import React from "react";
import PropTypes from "prop-types";
import { Form } from "antd";
import Password from "antd/lib/input/Password";
import { Trans, useTranslation } from "react-i18next";

const PasswordField = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Form.Item
        name={props.name}
        label={props.label}
        rules={[
          {
            required: true,
            message: <Trans>{t("val_password")}</Trans>,
          },
          () => ({
            validator(rule, value) {
              if (
                !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$.=!_%*#:?&])[A-Za-z\d@$.=!_%*#:?&]{8,}$/.test(
                  value
                )
              ) {
                return Promise.reject(
                  <Trans>{t("passsword_conditions")}</Trans>
                );
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Password
          name={props.name}
          placeholder={props.placeholder ? props.placeholder : t("pl_password")}
          onChange={props.handleInputChange}
          className={props.className}
          prefix={props.prefix}
          value={props.value ? props.value : null}
        />
      </Form.Item>
    </>
  );
};

PasswordField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  placeholder: PropTypes.string,
  handleInputChange: PropTypes.func,
  className: PropTypes.string,
  prefix: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PasswordField;
